//import template from './schema-epure-simple.html'
//import template from './schema-epure-complete.html'
import template from './schema-epure-creer-container.html'
import css from './schema-epure-creer.css'
import { SchemaEpureCreerController } from './schema-epure-creer.controller.js'

export const SchemaEpureCreerComponent = {
  template: template,
  templateNamespace:'svg',
  controller: SchemaEpureCreerController,
  controllerAs: 'SchemaEpureCreerController',
  bindings: {
    //clickMouvement: '='
  },
  require: {
    parentSimulator: '^^simulatorComponent'
  },
  bindings:{
  	svgcontent:'='
  }
}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/schema-epure-creer/schema-epure-creer.component.js